import { getAllBlogs } from "./getAllBlogs";

/**
 * Build Search G2 Query Params
 */

export function searchG2QueryParams(key: any, value: any)
{
    var g2Collection = window.DEFINE_VALUE.g2SearchBaseUrl;
    var langauge = window.location.href.split('/')[3].replace(/[^a-zA-Z ]/g, "") === "ca" ? "ca" : "us";
    
    var g2Brand = `&fq=custom_s_brand:corporate`; //brand:corporate
    var start;
    if(window.sessionStorage.getItem('pageNumber')){
        start = Number(window.sessionStorage.getItem('pageNumber'))*6;
    }else {
        start = 0;
    }
    //var prevArticleIndex = parseInt(localStorage.getItem('blog_article_prev_index') || 0);
    //var totalArticleCounts = parseInt(localStorage.getItem('blog_total_count') || 0);

    var otherParams = `?q=*&start=${start}&rows=6&wt=json&indent=true&sort=custom_dt_created desc`;
    var filteredParams = "&fl=custom_s_heading,custom_s_local_url,custom_t_content_summary_Desc,custom_s_article_summary_Image_url,custom_t_content_summary_Image_url_alt,custom_s_url";
    var g2CollectionURL;
    if (key && value)
    {
        g2CollectionURL = g2Collection + otherParams + '&fq=' + key + ':' + value + '&fq=custom_s_status:Active&fq=custom_s_country:'+langauge+'' + g2Brand + filteredParams;
    } else
    {
        g2CollectionURL = g2Collection + otherParams + '&fq=custom_s_status:Active&fq=custom_s_country:'+langauge+'' + g2Brand + filteredParams;
    }

    // Get All Blogs
    if(window.location.href.indexOf("press-center") >= 0)
        getAllBlogs(g2CollectionURL);
}

